/**
 * Os dois pontos em que o app gera telemetria (rodada 2B2):
 *
 *   - `useAberturaDoApp`: no Shell (há identidade e viagem ativa), uma vez
 *     por montagem — a classe decide se conta como abertura;
 *   - `useAreaPorRota`: a cada mudança de rota dentro do Shell, a área
 *     correspondente (`featureDaRota`), com o anti-ruído da classe;
 *   - `registrarAreaAberta`: para o que não é rota (a folha de feedback).
 *
 * Nada aqui lança nem bloqueia render.
 */
import { featureDaRota, type ProductFeature } from '@nv/core';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { telemetria } from './instalar';

export function registrarAreaAberta(feature: ProductFeature, tripId?: string): void {
  try {
    telemetria()?.featureAberta(feature, tripId);
  } catch {
    /* nunca */
  }
}

export function useAberturaDoApp(tripId: string | undefined): void {
  useEffect(() => {
    try {
      telemetria()?.appAberto(tripId);
    } catch {
      /* nunca */
    }
  }, [tripId]);
}

export function useAreaPorRota(tripId: string | undefined): void {
  const { pathname } = useLocation();
  useEffect(() => {
    const feature = featureDaRota(pathname);
    if (feature) registrarAreaAberta(feature, tripId);
  }, [pathname, tripId]);
}
